exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".preconfig img {\n  max-width: 50%;\n  display: block;\n  margin: 0 auto;\n}", ""]);

// exports
